import { render, staticRenderFns } from "./RegisterByMobile.vue?vue&type=template&id=864d3404&scoped=true&"
import script from "./RegisterByMobile.vue?vue&type=script&lang=js&"
export * from "./RegisterByMobile.vue?vue&type=script&lang=js&"
import style0 from "./RegisterByMobile.vue?vue&type=style&index=0&id=864d3404&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "864d3404",
  null
  
)

export default component.exports